module.exports = __webpack_public_path__ + "static/media/checkmark-circle.97dcdfe8.svg";